/* unplugin-vue-components disabled */
import {API_TASKS} from 'consts/api'
import TasksRunner from 'components/tasks-runner'

export default {
  components: {
    TasksRunner
  },
  props: {
    user: {type: Object, required: true}
  },
  data() {
    return {
      companies_filelist: [],
      contacts_filelist: []
    }
  },
  methods: {
    handleExceed(files, type) {
      const upload = this.$refs[`${type}_csv_file`]
      upload.clearFiles()
      const [file] = files
      upload.handleStart(file)
    },
    onFileChange(file, type) {
      if (file.name.split('.').length > 2 || !file.name.toLowerCase().endsWith('.csv')) {
        $utils.toasts.error('Please select a .csv file')
        this.$refs[`${type}_csv_file`].clearFiles()
      }
    },
    async runImport(tasks, type) {
      const filelist = this[`${type}_filelist`]
      if (!filelist.length) return undefined

      return await tasks.start(`${API_TASKS}/import/${type}?user_id=${this.user.id}`, filelist[0].raw, {fileData: true})
    }
  }
}
